const productElement = document.querySelector('.Product');
if (productElement && productElement.getAttribute('data-template') === 'product') {
  const openPopupButtons = document.querySelectorAll('.size-open-popup');
  const overlay = document.querySelector('.size-overlay');
  const closePopupButton = document.querySelector('.size-close');
  if (openPopupButtons.length > 0 && overlay && closePopupButton) {
    function showPopup() {
      overlay.classList.remove('size-overlay-hidden');
      overlay.classList.add('size-overlay-flex');
    }

    function hidePopup() {
      overlay.classList.add('size-overlay-hidden');
      overlay.classList.remove('size-overlay-flex');
    }

    openPopupButtons.forEach((openPopupButton) => {
      openPopupButton.addEventListener('click', function (event) {
        event.preventDefault();
        showPopup();
      });
    });

    closePopupButton.addEventListener('click', hidePopup);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        hidePopup();
      }
    });
  }
}
